
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
// import { JustifiPayoutDetails } from '@justifi/react-components';



const Payouts = props => {
    const [showModal, setShowModal] = useState(false);
    const [activeId, setActiveId] = useState('');
    const payoutRef = useRef(null);
    const timeoutIdRef = useRef(null);


    const handlePayoutRowClicked = (event) => {
        const data = event.detail?.data;

        if (!data) return;

        timeoutIdRef.current = setTimeout(() => {
            setShowModal(true);
            setActiveId(data.id);
        }, 100);
    };

    useEffect(() => {
        const payoutsList = payoutRef.current;
        
        if (payoutsList) {
            payoutsList.addEventListener('click-event', handlePayoutRowClicked);
        }

        return () => {
            if (payoutsList) {
                payoutsList.removeEventListener('click-event', handlePayoutRowClicked);
            }
            if (timeoutIdRef.current) {
                clearTimeout(timeoutIdRef.current);
            }
        };
    }, []); 

    const handleCloseModal = () => {
        setShowModal(false);
        setActiveId('');
    }


    return (
        <div className='coupon_table_wrapper px-10'>
                {
                    props.access_token ? (
                    <>
                    <justifi-payouts-list-filters/>
                    <justifi-payouts-list
                            auth-token={props.access_token}
                            account-id={props.subAccountId}
                            ref={payoutRef}
                        >
                        </justifi-payouts-list>
                    </>
                    ) : ''
                }



                    <Modal
                        show={showModal}
                        animation={false}
                        dialogClassName="payment_modal"
                        size="lg"
                        centered
                    >
                        <Modal.Body>
                            <span className="modal_close" onClick={handleCloseModal}><i className="icon-cross" /></span>
                            <justifi-payout-details
                                auth-token={props.access_token}
                                payout-id={activeId}
                            />
                        </Modal.Body>
                    </Modal>

        </div>
    )

}


const mapStateToProps = state => {
    let { userProfile } = state.user;
    let { campCode, subAccountId } = userProfile;

    return {
        campCode,
        subAccountId
    };
}


export default connect(mapStateToProps)(Payouts);
